import { Typography, Stack, Box } from '@mui/material';

import { UserAnswers } from '../../types';

import MonthlyExpenseCards from './MonthlyExpenseCards';

interface ReimbursementResultsProps {
    userAnswers: UserAnswers;
    onFillOutCurrentMonth?: () => void;
    onFillOutPreviousMonth?: () => void;
    onExpenseDataChange?: (data: {
        [month: string]: { homeOffice: number; phoneInternet: number; mileage: number };
    }) => void;
}

export default function ReimbursementResults({
    userAnswers,
    onFillOutCurrentMonth = () => {},
    onFillOutPreviousMonth = () => {},
    onExpenseDataChange = () => {},
}: ReimbursementResultsProps) {
    return (
        <Stack spacing={3} sx={{ textAlign: 'left' }}>
            <Typography variant="h1" sx={{ lineHeight: 1.2 }}>
                See how much you can get reimbursed
            </Typography>
            <Typography variant="body1">
                IRS rules require reimbursements to be reported within 60 days. We&apos;ll help you capture what
                qualifies.
            </Typography>
            <Box sx={{ mt: 4 }}>
                <MonthlyExpenseCards
                    userAnswers={userAnswers}
                    onFillOutCurrentMonth={onFillOutCurrentMonth}
                    onFillOutPreviousMonth={onFillOutPreviousMonth}
                    onExpenseDataChange={onExpenseDataChange}
                />
            </Box>
        </Stack>
    );
}
